import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PanelBodyLine = styled.div<{
  $isActive: boolean;
  $isSelected: boolean;
  $gridTemplateColumns: string;
}>`
  text-align: left;
  opacity: ${({ $isSelected }) => ($isSelected ? undefined : 0.4)};

  & > div {
    padding: ${spacing('lg')};
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.mainTextColor : theme.colors.paragraphTextColor};
  }

  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
  align-items: center;
`;

export const $AmountCell = styled.div`
  text-align: right;
  white-space: nowrap;
`;
